import { Component, DestroyRef, inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { CitizenIntroductionQuery } from "./store/citizen-introduction.query";
import { CitizenIntroductionService } from "./store/citizen-introduction.service";
import { CitizenIntroductionSteps } from "./store/citizen-introduction.store";
import { DashboardQuery } from "../store/dashboard.query";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "nerri-citizen-introduction",
    standalone: false,
    templateUrl: "./citizen-introduction.template.html",
    styleUrls: ["./citizen-introduction.style.scss"],
    encapsulation: ViewEncapsulation.None
})
export class CitizenIntroductionComponent implements OnInit {
    protected readonly currentStep$ = this.query.selectCurrentStep();
    protected readonly CitizenIntroductionSteps = CitizenIntroductionSteps;

    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private matDialogRef: MatDialogRef<CitizenIntroductionComponent>,
        private service: CitizenIntroductionService,
        private query: CitizenIntroductionQuery,
        private dashboardQuery: DashboardQuery
    ) {}

    public ngOnInit(): void {
        this.dashboardQuery
            .shouldShowIntroduction()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(showAll => {
                if (!showAll) {
                    this.service.setInitialStep(CitizenIntroductionSteps.Responsibility);
                }
            });
    }

    protected setPreviousStep(): void {
        this.service.setPreviousStep();
    }

    protected setNextStep(): void {
        this.service.setNextStep();
    }

    protected skipIntroduction(): void {
        this.matDialogRef.close();
    }
}
